import { ContextDocument } from "../../api/generated"

export default ContextDocument
